import { Component, Element, Event, EventEmitter, State } from '@stencil/core';
import { MamaFormTextfield } from './mama-form-textfield';
import { MamaSelect } from '../mama-select/mama-select';

declare const TYPO3: any;

@Component({
  tag: 'mama-form-gender',
  styleUrl: './mama-form-gender.scss',
})
export class MamaFormGender {
  @Element() el: HTMLElement;

  @State() showOwnInput: boolean = false;

  @Event({ bubbles: true }) mamaSelectChanged: EventEmitter<{ value: string; firstEvent: boolean; isInvalid: boolean }>;

  private fields: HTMLInputElement[];
  private title: HTMLSelectElement;
  private myTitle: MamaFormTextfield;
  private mySalutation: MamaFormTextfield;
  private titleSelect: MamaSelect;

  componentDidLoad() {
    this.title = document.querySelector('[data-genderselect="title"]');
    this.myTitle = document.querySelector('[data-genderselect="my-title"]') as any as MamaFormTextfield;
    this.mySalutation = document.querySelector('[data-genderselect="my-salutation"]') as any as MamaFormTextfield;
    this.fields = Array.from(this.el.querySelectorAll('input[type="radio"]'));
    this.titleSelect = this.title.querySelector('mama-select') as any as MamaSelect;

    this.fields.forEach(field => {
      field.addEventListener('click', () => {
        this.showOwnInput = field.value === 'own';
        this.setFieldsRequired();
        this.toggleFields();
      });
    });

    this.toggleFields();
  }

  toggleFields() {
    if (this.title) {
      this.title.hidden = this.showOwnInput;
    }
    if (this.myTitle) {
      this.myTitle.setHidden(!this.showOwnInput);
    }
    if (this.mySalutation) {
      this.mySalutation.setHidden(!this.showOwnInput);
    }
    if (this.titleSelect) {
      this.titleSelect.setHidden(this.showOwnInput);
    }
  }

  setFieldsRequired() {
    if (this.mySalutation) {
      this.mySalutation.setRequired(this.showOwnInput);
    }
    if (this.titleSelect) {
      this.titleSelect.setRequired(!this.showOwnInput);
    }

    const mamaSelectFields = Array.from(this.el.querySelectorAll('mama-select'));
    mamaSelectFields.forEach(field => {
      field.setRequired(!this.showOwnInput);
    });
  }

  hostData() {
    return {
      class: {
        'show-own-input': this.showOwnInput,
      },
    };
  }
}
